import { __decorate } from "tslib";
import { AutoEncoder, DateDecoder, field, IntegerDecoder, StringDecoder } from '@common/encoding';
import { v4 as uuidv4 } from 'uuid';
import { MemberDetails } from './MemberDetails.js';
export class TinyMember extends AutoEncoder {
    id;
    firstName = '';
    lastName = '';
    get name() {
        if (!this.firstName) {
            return this.lastName;
        }
        if (!this.lastName) {
            return this.firstName;
        }
        return this.firstName + ' ' + this.lastName;
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], TinyMember.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], TinyMember.prototype, "firstName", void 0);
__decorate([
    field({ decoder: StringDecoder })
], TinyMember.prototype, "lastName", void 0);
export class Member extends AutoEncoder {
    id;
    details;
    organizationId;
    /**
     * @deprecated
     */
    outstandingBalance = 0;
    createdAt = new Date();
    updatedAt = new Date();
    /**
     * The last time the member was registered.
     */
    lastRegisteredAt = null;
    get tiny() {
        return TinyMember.create({
            id: this.id,
            firstName: this.details.firstName,
            lastName: this.details.lastName,
        });
    }
    get isMinor() {
        return (this.details.age !== null && this.details.age < 18);
    }
    get lastName() {
        return this.details.lastName;
    }
    get firstName() {
        return this.details.firstName;
    }
    get name() {
        return this.details.name;
    }
    static sorterByName(sortDirection = 'ASC') {
        return (a, b) => {
            if (!a.details && !b.details) {
                return 0;
            }
            if (!a.details) {
                return 1;
            }
            if (!b.details) {
                return -1;
            }
            if (sortDirection == 'ASC') {
                if (a.details.name.toLowerCase() > b.details.name.toLowerCase()) {
                    return 1;
                }
                if (a.details.name.toLowerCase() < b.details.name.toLowerCase()) {
                    return -1;
                }
                return 0;
            }
            if (a.details.name.toLowerCase() > b.details.name.toLowerCase()) {
                return -1;
            }
            if (a.details.name.toLowerCase() < b.details.name.toLowerCase()) {
                return 1;
            }
            return 0;
        };
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], Member.prototype, "id", void 0);
__decorate([
    field({ decoder: MemberDetails, field: 'nonEncryptedDetails' }),
    field({ decoder: MemberDetails, version: 165 })
], Member.prototype, "details", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true, version: 399 })
], Member.prototype, "organizationId", void 0);
__decorate([
    field({ decoder: IntegerDecoder, optional: true })
], Member.prototype, "outstandingBalance", void 0);
__decorate([
    field({ decoder: DateDecoder, version: 31 })
], Member.prototype, "createdAt", void 0);
__decorate([
    field({ decoder: DateDecoder, version: 31 })
], Member.prototype, "updatedAt", void 0);
__decorate([
    field({ decoder: DateDecoder, version: 405, nullable: true })
], Member.prototype, "lastRegisteredAt", void 0);
//# sourceMappingURL=Member.js.map